module.exports = __webpack_public_path__ + "img/partnership_03_mobile.474ba16f.jpg";